import { baseApiUrl } from '@fund-base/constants/general/general.constants';

export const BasePhilanthropicContentRoute = `${baseApiUrl}/philanthropic-content`;
